import { render, staticRenderFns } from "./AgeAvatar.vue?vue&type=template&id=d4ba2922&"
import script from "./AgeAvatar.vue?vue&type=script&lang=js&"
export * from "./AgeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AgeAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports